module.exports = __webpack_public_path__ + "static/OffGrid-67fd4e08dbdcb9b078d060dc46a79420.jpg";